<template>
  <div class="pa-2">
    <section class="boarding-hierarchy-card">
      <draggable
        ref="drag"
        v-model="alocatedCargos"
        v-bind="dragOptions"
        multi-drag
        tag="div"
        selected-class="multi-drag"
        @add="onAdd"
      >
        <div class="pa-4">
          <v-card-text class="d-flex justify-space-between pa-0 pb-3" style="font-size: 1rem">
            <div class="d-flex">
              <div class="d-flex pr-1">
                <v-checkbox v-model="localSelected" class="ma-0 pa-0" hide-details></v-checkbox>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold"> Embarque: </span>
                <span class="font-weight-regular"> {{ boarding.boardingNumber }} </span>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Motorista: </span>

                <TruncateDataWithTooltip
                  :data="boarding.directDelivererName"
                  :lengthDataToTruncate="truncateLimit"
                ></TruncateDataWithTooltip>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Quilometragem total: </span>
                <span class="font-weight-regular">{{ boarding.totalMileage }}</span>
              </div>
              <div class="mr-4">
                <span class="font-weight-bold">Frete motorista: </span>
                <span class="font-weight-regular">{{ formatPrice(boarding.freightPrice) }}</span>
              </div>
            </div>
            <div class="d-flex">
              <v-icon v-if="isCollapsed" @click="isCollapsed = !isCollapsed">mdi-chevron-down</v-icon>
              <v-icon v-else @click="getStopsByCargo(true)">mdi-chevron-right</v-icon>
              <v-icon class="ml-2" @click="isEditDialogOpen = true"> mdi-pencil-outline </v-icon>
              <v-icon class="ml-2" @click="openDeleteDialog(boarding.id)"> mdi-close </v-icon>
            </div>
          </v-card-text>
          <v-card-text class="d-flex pa-0">
            <div>
              <span class="font-weight-bold text--secondary">Frete total dos transbordos: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(boarding.totalTranshipmentsPrice) }}</span>
            </div>
            <div>
              <span class="font-weight-bold text--secondary">Frete total dos embarcadores: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(boarding.totalDeliveriesPrice) }}</span>
            </div>
            <div>
              <span class="font-weight-bold text--secondary">Valor total das mercadorias: </span>
              <span class="font-weight-regular mr-4">{{ formatPrice(boarding.totalNfesPrice) }}</span>
            </div>
            <div>
              <span class="font-weight-bold text--secondary">Peso: </span>
              <span class="font-weight-regular mr-4">{{ formatWeight(boarding.weightCargos || 0) }}kg</span>
            </div>
            <div>
              <span class="font-weight-bold text--secondary">Quantidade de cargas: </span>
              <span class="font-weight-regular"> {{ boarding.amountCargos }} </span>
            </div>
          </v-card-text>
        </div>
        <v-data-table
          id="list02"
          class="w-100"
          v-if="isCollapsed"
          :headers="fileHeaders"
          :items="alocatedCargos"
          :items-per-page="alocatedCargos.length"
          :loading="isLoadingAlocated"
          loading-text="Carregando..."
          hide-default-footer
        >
          <template v-if="alocatedCargos.length > 0" v-slot:[`header.select`]="{}">
            <v-checkbox hide-details v-model="selectAll" class="pa-0 ma-0 ml-6"></v-checkbox>
          </template>
          <template #body="{}">
            <drag-table-alocated
              v-model="alocatedCargos"
              :boarding="boarding"
              :selectAll="selectAll"
              @update:allocated="unallocated"
              @update:selectAll="selectAll = $event"
              @loading:allocated="loadingAlocated"
            />
          </template>
        </v-data-table>
      </draggable>
    </section>
    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      @confirmClick="deleteBoarding()"
      title="Desfazer embarque"
      :body-text="confirmationText"
    />
    <confirm-dialog-form
      :isOpen.sync="isEditDialogOpen"
      :isBoarding="true"
      :boardingData="boarding"
      :isConfirmBtnLoading="isEditButtonLoading"
      @cancelClick="isEditDialogOpen = false"
      @confirmEditBoardingClick="updateBoarding"
    />
  </div>
</template>

<script>
import DeleteConfirmDialog from '@/components/ConfirmDialog.vue';
import TruncateDataWithTooltip from '@/components/Table/TruncateDataWithTooltip.vue';
import ConfirmDialogForm from '@/components/ManualBoardingImport/Stepper/ConfirmDialogForm.vue';
import DragTableAlocated from '@/components/ManualBoardingImport/Stepper/Step6/DragTableAlocated.vue';
import maskPrice from '@/utils/maskPrice';
import copyToClipboard from '@/utils/copyToClipboard';
import maskWeight from '@/utils/maskWeight';
import { mapActions } from 'vuex';
import draggable from 'vuedraggable';

export default {
  components: {
    DeleteConfirmDialog,
    TruncateDataWithTooltip,
    ConfirmDialogForm,
    DragTableAlocated,
    draggable
  },
  props: {
    boarding: {
      default: () => ({}),
      type: Object
    },

    selected: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoadingAlocated: false,
    isDeleteDialogOpen: false,
    isDeleteButtonLoading: false,
    isEditDialogOpen: false,
    isEditButtonLoading: false,
    isCollapsed: false,
    selectAll: false,
    selectedNfe: {},
    alocatedCargos: [],
    dragOptions: {
      animation: 150,
      group: 'cargosAllocation',
      ghostClass: 'ghost',
      disabled: false,
      handle: 'none'
    }
  }),
  async mounted() {
    window.addEventListener('resize', this.truncateLimitSidebar());
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.truncateLimitSidebar());
  },
  computed: {
    localSelected: {
      get() {
        return this.selected;
      },
      set() {
        this.$emit('update:selected', this.boarding.id);
      }
    },
    fileHeaders() {
      const baseHeaders = [
        { value: 'select', text: '', sortable: false },
        { value: 'cargoNumber', text: 'NÚMERO DA CARGA', sortable: true },
        { value: 'totalPriceNfes', text: 'VALOR MERCADORIAS', sortable: true },
        { value: 'weightDeliveries', text: 'PESO', sortable: true },
        { value: 'isDirectDelivery', text: 'TIPO', sortable: true }
      ];

      const hasIndirectDelivery =
        Array.isArray(this.alocatedCargos) && this.alocatedCargos.some((cargo) => !cargo.isDirectDelivery);

      if (hasIndirectDelivery) {
        baseHeaders.splice(
          2,
          0,
          { value: 'totalTranshipmentPrice', text: 'FRETE TRANSBORDO', sortable: true },
          { value: 'transhipmentName', text: 'TRANSBORDO', sortable: true }
        );
      }

      return baseHeaders;
    },
    confirmationText() {
      if (this.boarding.amountCargos === 0) {
        return 'Você confirma excluir esse Embarque?';
      } else {
        return 'Confirmar dasalocar os cargos e excluir esse Embarque?';
      }
    },
    truncateLimit() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1440) return 8;
      if (width < 1520) return 16;
      return 34;
    },
    truncateLimitFreight() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1680) return 0;
      return 34;
    }
  },
  methods: {
    ...mapActions('SidebarStore', ['changeCollapse']),
    ...mapActions('ImportManualBoardingsStore', ['getCargosByBoardingId', 'editBoarding', 'allocateCargo']),
    async getStopsByCargo(collapsed = false) {
      this.isLoadingAlocated = true;
      try {
        if (collapsed) {
          this.isCollapsed = !this.isCollapsed;
        }
        const data = await this.getCargosByBoardingId(this.boarding.id);
        this.alocatedCargos = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoadingAlocated = false;
      }
    },
    loadingAlocated(loading) {
      this.alocatedCargos = [];
      this.isLoadingAlocated = loading;
    },
    openDeleteDialog() {
      this.isDeleteDialogOpen = true;
    },
    deleteBoarding() {
      this.$emit('removeBoarding', this.boarding.id);
      this.isDeleteDialogOpen = false;
    },
    unallocated(value, msg) {
      this.$emit('update:allocated', value, msg);
      this.getStopsByCargo();
    },
    formatPrice(price) {
      return maskPrice(price);
    },
    formatWeight(price) {
      return maskWeight(price);
    },
    copy(str) {
      copyToClipboard(str);
    },
    async allocateCargoToBoarding(cargos) {
      try {
        let cargosIds;
        if (Array.isArray(cargos)) {
          cargosIds = cargos.map(({ id }) => id);
        } else {
          cargosIds = [cargos.id];
        }
        const params = {
          id: this.boarding.id,
          cargosIds: cargosIds
        };

        const response = await this.allocateCargo(params);
        if (response.success) {
          this.unallocated('Entrega(s) alocadas com sucesso!', true);
        } else {
          const draggedItemIndex = this.alocatedCargos.findIndex((item) => item === cargos);
          this.alocatedCargos.splice(draggedItemIndex, 1);
          this.$emit(
            'update:allocated',
            response.errors[0] || 'Entrega(s) com destinatário ou remetente distintos!',
            false
          );
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onAdd(e) {
      this.loadingAlocated(true);
      if (e.item._selected_items.length > 1) {
        const draggedItems = e.item._selected_items;
        await this.allocateCargoToBoarding(draggedItems);
      } else {
        await this.allocateCargoToBoarding(e.item._underlying_vm_);
      }
      await this.loadingAlocated(false);
      await this.getStopsByCargo();
      this.$emit('update:selectAll', false);
    },
    async updateBoarding(value) {
      this.isEditButtonLoading = true;
      try {
        const model = {
          id: this.boarding.id,
          ...value
        };
        const response = await this.editBoarding(model);
        this.$emit('update:editBoarding', response);
      } catch (err) {
        console.error(err);
      } finally {
        this.isEditButtonLoading = false;
      }
    },
    async truncateLimitSidebar() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 1460) this.changeCollapse(true);
    }
  }
};
</script>

<style scoped>
* {
  transition: 0ms;
}
.ghost {
  display: none !important;
}
.boarding-hierarchy-card {
  min-width: 560px;
  width: 100%;
  min-height: 90px;
  height: auto;
  border-radius: 3px;
  border: solid 1px #f1f1f1;
  box-shadow: 1px 4px 3px rgba(23, 23, 23, 0.28);
}
</style>